/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SalesAchievements model module.
 * @module model/SalesAchievements
 * @version 1.0.0
 */
class SalesAchievements {
    /**
     * Constructs a new <code>SalesAchievements</code>.
     * @alias module:model/SalesAchievements
     */
    constructor() { 
        
        SalesAchievements.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SalesAchievements</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SalesAchievements} obj Optional instance to populate.
     * @return {module:model/SalesAchievements} The populated <code>SalesAchievements</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SalesAchievements();

            if (data.hasOwnProperty('achievement_name')) {
                obj['achievement_name'] = ApiClient.convertToType(data['achievement_name'], 'String');
            }
            if (data.hasOwnProperty('achievement_area')) {
                obj['achievement_area'] = ApiClient.convertToType(data['achievement_area'], 'String');
            }
            if (data.hasOwnProperty('achievement_price')) {
                obj['achievement_price'] = ApiClient.convertToType(data['achievement_price'], 'Number');
            }
            if (data.hasOwnProperty('file_url')) {
                obj['file_url'] = ApiClient.convertToType(data['file_url'], 'String');
            }
            if (data.hasOwnProperty('object_storage_path')) {
                obj['object_storage_path'] = ApiClient.convertToType(data['object_storage_path'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SalesAchievements</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SalesAchievements</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['achievement_name'] && !(typeof data['achievement_name'] === 'string' || data['achievement_name'] instanceof String)) {
            throw new Error("Expected the field `achievement_name` to be a primitive type in the JSON string but got " + data['achievement_name']);
        }
        // ensure the json data is a string
        if (data['achievement_area'] && !(typeof data['achievement_area'] === 'string' || data['achievement_area'] instanceof String)) {
            throw new Error("Expected the field `achievement_area` to be a primitive type in the JSON string but got " + data['achievement_area']);
        }
        // ensure the json data is a string
        if (data['file_url'] && !(typeof data['file_url'] === 'string' || data['file_url'] instanceof String)) {
            throw new Error("Expected the field `file_url` to be a primitive type in the JSON string but got " + data['file_url']);
        }
        // ensure the json data is a string
        if (data['object_storage_path'] && !(typeof data['object_storage_path'] === 'string' || data['object_storage_path'] instanceof String)) {
            throw new Error("Expected the field `object_storage_path` to be a primitive type in the JSON string but got " + data['object_storage_path']);
        }

        return true;
    }


}



/**
 * @member {String} achievement_name
 */
SalesAchievements.prototype['achievement_name'] = undefined;

/**
 * @member {String} achievement_area
 */
SalesAchievements.prototype['achievement_area'] = undefined;

/**
 * @member {Number} achievement_price
 */
SalesAchievements.prototype['achievement_price'] = undefined;

/**
 * @member {String} file_url
 */
SalesAchievements.prototype['file_url'] = undefined;

/**
 * @member {String} object_storage_path
 */
SalesAchievements.prototype['object_storage_path'] = undefined;






export default SalesAchievements;

